import { AfterContentInit, Component,ViewChild, OnInit,ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute,Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from '../service/auth.service';
import { environment, env_data } from 'src/environments/environment';

@Component({
  selector: 'app-validate-mobile-user',
  templateUrl: './validate-mobile-user.component.html',
  styleUrls: ['./validate-mobile-user.component.css']
})
export class ValidateMobileUserComponent implements OnInit {
  isLoading = true;
  showErr = false;
  showSuccess = false;
  myAccessToken:string = this.route.snapshot.params.token;
  @ViewChild('recaptcha', { static: true }) recaptchaElement: ElementRef;
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    withCredentials: true,
  };


  constructor(
    private router: Router,
    private http: HttpClient,
    private route:ActivatedRoute,
    private fb: FormBuilder,
    private authService: AuthService) { }

  ngOnInit(): void {
    
    this.validateRealUser();
    this.addRecaptchaScript();
  }

  renderReCaptch() {

    
    let element = this.recaptchaElement.nativeElement;
    window['grecaptcha'].render(element, {
      'sitekey' : env_data.google_site_key,
      'callback': (response) => {
          this.sendGoogleVerification(response);
          
      }
    });
  }

  addRecaptchaScript() {
 
    window['grecaptchaCallback'] = () => {
      this.renderReCaptch();

      //this.deleteCookies()
    }
 
    var that = this;
    (function(d, s, id, obj){
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) { obj.renderReCaptch(); return;}
      js = d.createElement(s); js.id = id;
      js.src = "https://www.google.com/recaptcha/api.js?onload=grecaptchaCallback&amp;render=explicit";
      fjs.parentNode.insertBefore(js, fjs);
      
    }(document, 'script', 'recaptcha-jssdk', this));
 
  }

  validateRealUser(){
    
    var req = {
      token: this.myAccessToken
    }
    

    this.http.post(environment.USER_VALIDATE_TOKEN,req, this.httpOptions).subscribe(
      (res: any) => {
        this.isLoading = false;
        if(res.status == 200 ) {
          console.log('käyttäjä on nyt aktivoitu');
          var elm = document.getElementById('my-cont');
          elm.style.display = "block";

        }
        else {
          this.showErr = true;
          window.location.href = 'formedmobileapp://'

          setTimeout(() => {
            //window.location.href = 'https://formed.fi';
          },10000)
        }
        
      }, (err: any) => {
  
        console.log("Error while finding status :: ", err);
      })
  } 

  toApp(){
    window.location.href = 'formedmobile://activation-successfull'
  }

  sendGoogleVerification(response){

    this.isLoading = true;
    var req = {
      token: this.myAccessToken,
      response: response
    }

    //Hide #my-cont


    console.log(req);


    this.http.post(environment.USER_VALIDATE_CAPTCHA,req, this.httpOptions).subscribe(
      (res: any) => {
        this.showSuccess = true;
        if(res.status == 200 ) {
          console.log('JEee')

          console.log(res.message, this.showSuccess)
          document.getElementById('success').classList.replace('d-none','d-block');

          //Hide #my-cont
          var elm = document.getElementById('my-cont');
          elm.style.display = "none";
        }
        else {
          console.log('Error while validating profile')
          this.showErr = true;
          this.isLoading = false;

          document.getElementById('error').classList.replace('d-none','d-block');
        }
        
      }, (err: any) => {
  
        console.log("Error while finding status :: ", err);
      })

  }

}
